import { createContext, useState } from "react";

export const Auth = createContext();

const AuthContext = ({ children }) => {
  const [formData, setFormData] = useState();
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;
  const user = localStorage.getItem("user");
  const totalFavoriteCounts = parseInt(
    localStorage.getItem("favCounts") ? localStorage.getItem("favCounts") : "0"
  );
  const userRole = localStorage.getItem("userRole")
    ? localStorage.getItem("userRole")
    : null;

  const [auth, setAuth] = useState({
    token,
    user: user ? JSON.parse(user) : null,
    userRole,
  });

  const [showSidebar, setShowSidebar] = useState(false);
  const [favoriteCounts, setFavoriteCounts] = useState(totalFavoriteCounts);
  const [visibility, setVisibility] = useState(false);


  const logOut = () => {
    localStorage.clear();
    setAuth({ token: null, user: null, userRole: null });
    window.location.replace(window.location.origin + "/dream-star/");
  };
  const DeleteAccount = () => {
    localStorage.clear();
    setAuth({ token: null, user: null, userRole: null });
    window.location.replace(window.location.origin + "/dream-star/");
  };

  return (
    <Auth.Provider
      value={{
        auth,
        setAuth,
        logOut,
        DeleteAccount,
        formData,
        setFormData,
        showSidebar,
        setShowSidebar,
        visibility,
        setVisibility,
        favoriteCounts,
        setFavoriteCounts,
        
      }}
    >
      {children}
    </Auth.Provider>
  );
};

export default AuthContext;
